import RadioButton from '@ebsco-ui/radio-button';
import DateRange from '@ebsco-ui/date-range';
import { createBemBlockBuilder } from '@ebsco-ui/utils';
import { jsxs, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["groupTitle"],
    _excluded2 = ["className", "dateRange", "i18n", "isSharedError", "quickFilters", "placeholder", "selectedFilter", "showDateRange", "uniqueName", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var baseClassName = "eb-date-filters";
var DateFilters = function DateFilters(props) {
  var className = props.className,
      dateRange = props.dateRange,
      _props$i18n = props.i18n,
      groupTitle = _props$i18n.groupTitle,
      dateRangeI18n = _objectWithoutProperties(_props$i18n, _excluded),
      isSharedError = props.isSharedError,
      quickFilters = props.quickFilters,
      placeholder = props.placeholder,
      selectedFilter = props.selectedFilter,
      showDateRange = props.showDateRange,
      _props$uniqueName = props.uniqueName,
      uniqueName = _props$uniqueName === void 0 ? "date-filter" : _props$uniqueName,
      onChange = props.onChange,
      rest = _objectWithoutProperties(props, _excluded2);

  var getBlocksWith = createBemBlockBuilder([baseClassName, className]);

  var handleChange = function handleChange(value) {
    onChange({
      selectedFilter: value,
      // send back for consistency
      customRange: {
        minDate: dateRange.minDate.value,
        maxDate: dateRange.maxDate.value
      }
    });
  };

  var handleCustomRangeChange = function handleCustomRangeChange(minDate, maxDate) {
    onChange({
      selectedFilter: selectedFilter,
      customRange: {
        minDate: minDate,
        maxDate: maxDate
      }
    });
  };

  var dateRangeUniqueName = "".concat(uniqueName, "-custom-range");
  return /*#__PURE__*/jsxs("div", {
    className: getBlocksWith(),
    children: [/*#__PURE__*/jsx("div", _objectSpread(_objectSpread({
      className: getBlocksWith("__group")
      /* Keep role and aria-label as defaults for backward compatibility */
      ,
      role: "group",
      "aria-label": groupTitle,
      "data-auto": "quick-date-filters-group"
    }, rest), {}, {
      children: quickFilters.map(function (_ref) {
        var label = _ref.label,
            value = _ref.value;
        return /*#__PURE__*/jsx(RadioButton, {
          label: label,
          name: uniqueName,
          value: value,
          onChange: function onChange(ev) {
            return handleChange( // input converts all values to string, we have to convert it back to number to make the component work correctly
            typeof value === "number" ? Number(ev.target.value) : ev.target.value);
          },
          checked: selectedFilter === value,
          className: getBlocksWith("__filter"),
          "data-auto": "quick-date-filter"
        }, value);
      })
    })), showDateRange && /*#__PURE__*/jsx(DateRange, {
      i18n: dateRangeI18n,
      minDate: dateRange.minDate,
      maxDate: dateRange.maxDate,
      isSharedError: isSharedError,
      onChange: handleCustomRangeChange,
      placeholder: placeholder,
      uniqueName: dateRangeUniqueName,
      className: getBlocksWith("-date-range")
    })]
  });
};

export { DateFilters, DateFilters as default };
//# sourceMappingURL=date-filters-esm.js.map
